var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuoteActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.76636H10.8C9.77996 7.76636 9.07996 6.99301 9.07996 6.04635V3.89966C9.07996 2.95299 9.77996 2.17969 10.8 2.17969H12.9466C13.8933 2.17969 14.6666 2.95299 14.6666 3.89966V7.76636Z",
    stroke: "#0FC7E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 7.76562C14.6666 11.799 13.9133 12.4656 11.6466 13.8123",
    stroke: "#0FC7E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91333 7.76636H3.04666C2.02666 7.76636 1.32666 6.99301 1.32666 6.04635V3.89966C1.32666 2.95299 2.02666 2.17969 3.04666 2.17969H5.19999C6.14666 2.17969 6.91999 2.95299 6.91999 3.89966V7.76636",
    stroke: "#0FC7E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91331 7.76562C6.91331 11.799 6.15998 12.4656 3.89331 13.8123",
    stroke: "#0FC7E6",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoteActive);
export default __webpack_public_path__ + "static/media/quoteActive.0ba09b51e0219b9b74f47754140848f5.svg";
export { ForwardRef as ReactComponent };